import PropTypes from 'prop-types';

import companyActivationStrings from 'modules/companyActivation/strings';

import {
  Wrapper,
  SearchBarWrapper,
  SearchBar,
  SearchBarIcon,
} from './CompanyActivationFilter.style';

const CompanyActivationFilter = ({ searchQuery, handleSearchBarInputChange }) => (
  <Wrapper>
    <SearchBarWrapper>
      <SearchBarIcon />
      <SearchBar
        placeholder={companyActivationStrings.companyActivationFilter.searchBarPlaceholder}
        value={searchQuery}
        onChange={handleSearchBarInputChange}
      />
    </SearchBarWrapper>
  </Wrapper>
);
CompanyActivationFilter.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
};

export default CompanyActivationFilter;
